// START Change cart promo header for mobile
if($(window).width() < 568) {
   console.log($(window).width());
    $(".cart-promo-header-img").each(function() {
      
      $(this).attr("src", "https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_Christmas-in-July_Free-Ornament_Gallery-Cart-Assets_20260722-03.jpg?v=1784664572"); 
                });
            } else if ($(window).width() >= 568) {
                
                $(".cart-promo-header-img").each(function() {
                $(this).attr("src","https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_Christmas-in-July_Free-Ornament_Gallery-Cart-Assets_20260722-02.jpg?v=1784664572");

                });                        
    };
// END Change logo for mobile